import { onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { usePermisos } from './usePermisos'

/**
 * Composable de atajos de teclado globales.
 * Se activa en MainLayout para que funcione en todas las páginas autenticadas.
 *
 * Atajos disponibles:
 * - Alt+N → Nueva Factura
 * - Alt+C → Nuevo Crédito Fiscal
 * - Alt+H → Historial de DTEs
 * - Alt+D → Dashboard
 * - Alt+R → Reportes
 * - Alt+B → Buscar (enfoca el primer input de búsqueda visible)
 */
export function useKeyboardShortcuts() {
  const router = useRouter()
  const { puedeCrearFactura, puedeCrearCreditoFiscal, puedeVerHistorial, puedeVerReportes } = usePermisos()

  const handleKeydown = (e) => {
    // No activar si estamos en un input, textarea o select
    const tagName = e.target.tagName.toLowerCase()
    if (['input', 'textarea', 'select'].includes(tagName)) return

    // No activar si hay un dialog/modal abierto
    if (document.querySelector('.v-overlay--active .v-dialog')) return

    if (!e.altKey) return

    switch (e.key.toLowerCase()) {
      case 'n':
        if (puedeCrearFactura.value) {
          e.preventDefault()
          router.push({ name: 'emision-factura' })
        }
        break
      case 'c':
        if (puedeCrearCreditoFiscal.value) {
          e.preventDefault()
          router.push({ name: 'emision-ccf' })
        }
        break
      case 'h':
        if (puedeVerHistorial.value) {
          e.preventDefault()
          router.push({ name: 'historial' })
        }
        break
      case 'd':
        e.preventDefault()
        router.push({ name: 'dashboard' })
        break
      case 'r':
        if (puedeVerReportes.value) {
          e.preventDefault()
          router.push({ name: 'reportes' })
        }
        break
      case 'b':
        e.preventDefault()
        const searchInput = document.querySelector('.v-text-field input[type="text"]')
        if (searchInput) searchInput.focus()
        break
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', handleKeydown)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', handleKeydown)
  })
}
